// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"4924ca71","348":"7224410d","558":"fd021bb8","571":"2c2251ca"}[chunkId] + ".chunk.js";
};